/* Click a swatch = swap main + hover images (no hover preview) */
(() => {
  function buildSrcset(baseUrl) {
    const widths = [165, 360, 533, 720, 940, 1066, 1200, 1500];
    const clean = baseUrl.split('?')[0];
    return widths.map(w => `${clean}?width=${w} ${w}w`).join(', ');
  }

  function updateImg(el, url) {
    if (!el || !url) return;
    const clean = url.split('?')[0];
    el.src = `${clean}?width=720`;
    el.srcset = buildSrcset(clean);
  }

  function handlePick(swatch) {
    const card = swatch.closest('[data-product-card]');
    if (!card) return;

    // Main image
    const mainImg = card.querySelector('[data-card-image]');
    if (mainImg && swatch.dataset.image) updateImg(mainImg, swatch.dataset.image);

    // Hover/second image (if present)
    const hoverImg = card.querySelector('[data-card-image-secondary]');
    const sec = swatch.dataset.imageSecondary;
    if (hoverImg && sec) {
      updateImg(hoverImg, sec);
    }

    // Active state
    card.querySelectorAll('[data-variant-swatch].is-active').forEach(el => el.classList.remove('is-active'));
    swatch.classList.add('is-active');

    // Keep tile link in sync with chosen variant
    const link = card.querySelector('a[href*="/products/"]');
    if (link && swatch.dataset.variantId) {
      const u = new URL(link.href, location.origin);
      u.searchParams.set('variant', swatch.dataset.variantId);
      link.href = u.pathname + u.search;
    }
  }

  // Click only
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('[data-variant-swatch]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    handlePick(swatch);
  }, true);

  // Keyboard a11y
  document.addEventListener('keydown', (e) => {
    const swatch = e.target.closest('[data-variant-swatch]');
    if (!swatch) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopPropagation();
    handlePick(swatch);
  }, true);
})();
